export const MAX_DELIVERY_PHOTOS = 10;

export function getCurrentLocation(options = {}) {
  const { timeout = 15000, enableHighAccuracy = true } = options;
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (position.coords.latitude == null || position.coords.longitude == null) {
          reject(new Error('Invalid GPS coordinates received.'));
          return;
        }
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        let message = 'Failed to get GPS location. ';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message += 'Location permission denied.';
            break;
          case error.POSITION_UNAVAILABLE:
            message += 'GPS position unavailable.';
            break;
          case error.TIMEOUT:
            message += 'GPS request timed out.';
            break;
          default:
            message += error.message || 'Unknown error.';
        }
        reject(new Error(message));
      },
      { timeout, enableHighAccuracy, maximumAge: 0 },
    );
  });
}

/** Build multipart FormData for POST /jobs/{id}/delivery-photos/upload/ */
export function buildAddDeliveryPhotosFormData({ deliveryPhotos, latitude, longitude }) {
  const fd = new FormData();
  const meta = [];
  (deliveryPhotos || []).forEach((p) => {
    fd.append('delivery_photos', p.file);
    meta.push({
      latitude: p.latitude != null ? p.latitude : null,
      longitude: p.longitude != null ? p.longitude : null,
    });
  });
  fd.append('delivery_photo_meta', JSON.stringify(meta));
  if (latitude != null && longitude != null) {
    fd.append('latitude', String(latitude));
    fd.append('longitude', String(longitude));
  }
  return fd;
}
